/**
 * Alloy Integration Settings Type
 */
export interface IAlloySetting {
  isEnabled: boolean;
  applicationToken: string;
  applicationSecret: string;
  socurePublicToken?: string;
  socureEnabled: boolean;
  journeys: IAlloyJourney[];
  sandboxMode?: boolean;
}
/**
 * Alloy Journey Type
 */
export interface IAlloyJourney {
  id: string;
  displayName: string;
  sdkKey: string;
  journeyToken: string;
  canRerun: boolean;
  isDeniedBlocking: boolean;
  allowCoApplicants: boolean;
  loanGroups?: ILink[];
  memberships?: ILink[];
  useSocure: boolean;
  enableAlloyPrefill: boolean;
  overrideJourneyVersion?: string;
  sandboxHeaderOverrides?: string;
  branchName?: string;
}
export interface ILink {
  name: string;
  id: string;
  children: ILink[];
}
/** Alloy Integration Settings class */
export class AlloySetting implements IAlloySetting {
  public isEnabled: boolean;
  public applicationToken: string;
  public applicationSecret: string;
  public journeys: IAlloyJourney[] = [];
  public socureEnabled: boolean;
  public socurePublicToken?: string;
  public sandboxMode?: boolean;
}
/**
 * Alloy Journey Class
 */
export class AlloyJourney implements IAlloyJourney {
  public id: string;
  public displayName: string;
  public sdkKey: string;
  public journeyToken: string;
  public canRerun: boolean;
  public allowCoApplicants: boolean;
  public useSocure: boolean;
  public isDeniedBlocking: boolean;
  public enableAlloyPrefill: boolean;
  public branchName?: string;
}
